<template>
  <div class="invoice-page">
    <!-- 统计卡片 -->
    <div class="statistics-cards">
      <div class="stat-card">
        <div class="stat-label">本月发票金额</div>
        <div class="stat-value">{{ formatMoney(statistics.currentMonthAmount) }}</div>
      </div>
      <div class="stat-card">
        <div class="stat-label">销项发票</div>
        <div class="stat-value">{{ getTypeCount(0) }}张</div>
      </div>
      <div class="stat-card">
        <div class="stat-label">进项发票</div>
        <div class="stat-value">{{ getTypeCount(1) }}张</div>
      </div>
    </div>

    <div class="toolbar">
      <Button color="primary" @click="openCreate">新增发票</Button>
      <Button @click="load">刷新</Button>
      <Button @click="goToBusinessType">业务类型管理</Button>
    </div>

    <Table :datas="list" :loading="loading">
      <TableItem title="发票类型" align="center" :width="100">
        <template slot-scope="{data}">
          <span :class="'type-' + data.type">{{ getInvoiceTypeText(data.type) }}</span>
        </template>
      </TableItem>
      <TableItem title="发票代码" prop="invoiceCode" align="center" :width="120"></TableItem>
      <TableItem title="发票号码" prop="invoiceNumber" align="center" :width="120"></TableItem>
      <TableItem title="交易日期" prop="tradeDate" align="center" :width="110"></TableItem>
      <TableItem title="客户名称" prop="customerName" align="left"></TableItem>
      <TableItem title="金额" align="right" :width="120">
        <template slot-scope="{data}">
          {{ formatMoney(data.amount) }}
        </template>
      </TableItem>
      <TableItem title="税额" align="right" :width="100">
        <template slot-scope="{data}">
          {{ formatMoney(data.taxAmount) }}
        </template>
      </TableItem>
      <TableItem title="状态" align="center" :width="80">
        <template slot-scope="{data}">
          <span :class="'status-' + data.state">{{ getStatusText(data.state) }}</span>
        </template>
      </TableItem>
      <TableItem title="操作" align="center" :width="150">
        <template slot-scope="{data}">
          <Button text size="xs" @click="openEdit(data)">编辑</Button>
          <Button text size="xs" color="orange" @click="voidInvoice(data)" v-if="data.state === 0">作废</Button>
          <Button text size="xs" color="red" @click="remove(data)">删除</Button>
        </template>
      </TableItem>
    </Table>

    <!-- 新增/编辑弹窗 -->
    <Modal v-model="showModal" :hasCloseIcon="true" :width="900">
      <div class="modal-header">
        <div class="modal-title">{{ isEdit ? '编辑发票' : '新增发票' }}</div>
        <div class="modal-subtitle">{{ isEdit ? '修改发票信息' : '录入新的发票信息' }}</div>
      </div>
      <Form ref="form" :model="form" :rules="rules" labelPosition="left" :labelWidth="140">
        <div class="form-row">
          <FormItem label="发票类型" prop="type" class="form-col">
            <Select v-model="form.type" :datas="invoiceTypes" placeholder="请选择发票类型" />
          </FormItem>
          <FormItem label="业务类型" class="form-col">
            <Select v-model="form.businessTypeId" :datas="businessTypes" keyName="id" titleName="title" placeholder="请选择业务类型" />
          </FormItem>
        </div>
        <div class="form-row">
          <FormItem label="交易日期" prop="tradeDate" class="form-col">
            <DatePicker v-model="form.tradeDate" type="date" placeholder="请选择交易日期" />
          </FormItem>
          <FormItem label="发票代码" prop="invoiceCode" class="form-col">
            <input type="text" v-model="form.invoiceCode" placeholder="请输入发票代码" style="width: 100%; height: 36px; padding: 0 10px; border: 1px solid #d9d9d9; border-radius: 4px;" />
          </FormItem>
        </div>
        <div class="form-row">
          <FormItem label="发票号码" prop="invoiceNumber" class="form-col">
            <input type="text" v-model="form.invoiceNumber" placeholder="请输入发票号码" style="width: 100%; height: 36px; padding: 0 10px; border: 1px solid #d9d9d9; border-radius: 4px;" />
          </FormItem>
          <FormItem label="客户名称" class="form-col">
            <input type="text" v-model="form.customerName" placeholder="请输入客户名称" style="width: 100%; height: 36px; padding: 0 10px; border: 1px solid #d9d9d9; border-radius: 4px;" />
          </FormItem>
        </div>
        <div class="form-row">
          <FormItem label="信用代码/税号" class="form-col">
            <input type="text" v-model="form.creditCode" placeholder="请输入信用代码或税号" style="width: 100%; height: 36px; padding: 0 10px; border: 1px solid #d9d9d9; border-radius: 4px;" />
          </FormItem>
          <FormItem label="地址" class="form-col">
            <input type="text" v-model="form.address" placeholder="请输入地址" style="width: 100%; height: 36px; padding: 0 10px; border: 1px solid #d9d9d9; border-radius: 4px;" />
          </FormItem>
        </div>
        <div class="form-row">
          <FormItem label="备注" class="form-col" style="width: 100%;">
            <input type="text" v-model="form.note" placeholder="请输入备注" style="width: 100%; height: 36px; padding: 0 10px; border: 1px solid #d9d9d9; border-radius: 4px;" />
          </FormItem>
        </div>

        <!-- 发票项目明细 -->
        <div class="items-section">
          <div class="items-header">
            <span class="items-title">发票项目明细</span>
            <Button size="xs" color="primary" @click="addItem">添加项目</Button>
          </div>
          <Table :datas="form.items" :border="true" size="s">
            <TableItem title="商品/服务名称" align="center">
              <template slot-scope="{data, index}">
                <input type="text" v-model="data.goodsName" placeholder="商品名称" style="width: 100%; height: 28px; padding: 0 5px; border: 1px solid #d9d9d9; border-radius: 2px;" />
              </template>
            </TableItem>
            <TableItem title="规格型号" align="center" :width="100">
              <template slot-scope="{data, index}">
                <input type="text" v-model="data.specification" placeholder="规格" style="width: 100%; height: 28px; padding: 0 5px; border: 1px solid #d9d9d9; border-radius: 2px;" />
              </template>
            </TableItem>
            <TableItem title="单位" align="center" :width="60">
              <template slot-scope="{data, index}">
                <input type="text" v-model="data.unit" placeholder="单位" style="width: 100%; height: 28px; padding: 0 5px; border: 1px solid #d9d9d9; border-radius: 2px;" />
              </template>
            </TableItem>
            <TableItem title="数量" align="center" :width="80">
              <template slot-scope="{data, index}">
                <input type="number" v-model="data.quantity" placeholder="数量" @change="calcItemAmount(data)" style="width: 100%; height: 28px; padding: 0 5px; border: 1px solid #d9d9d9; border-radius: 2px;" />
              </template>
            </TableItem>
            <TableItem title="金额" align="center" :width="100">
              <template slot-scope="{data, index}">
                <input type="number" v-model="data.amount" placeholder="金额" @change="calcTotalAmount" style="width: 100%; height: 28px; padding: 0 5px; border: 1px solid #d9d9d9; border-radius: 2px;" />
              </template>
            </TableItem>
            <TableItem title="税率(%)" align="center" :width="80">
              <template slot-scope="{data, index}">
                <input type="number" v-model="data.taxRate" placeholder="税率" @change="calcItemTax(data)" style="width: 100%; height: 28px; padding: 0 5px; border: 1px solid #d9d9d9; border-radius: 2px;" />
              </template>
            </TableItem>
            <TableItem title="税额" align="center" :width="100">
              <template slot-scope="{data, index}">
                <input type="number" v-model="data.tax" placeholder="税额" @change="calcTotalAmount" style="width: 100%; height: 28px; padding: 0 5px; border: 1px solid #d9d9d9; border-radius: 2px;" />
              </template>
            </TableItem>
            <TableItem title="操作" align="center" :width="60">
              <template slot-scope="{data, index}">
                <Button text size="xs" color="red" @click="removeItem(index)">删除</Button>
              </template>
            </TableItem>
          </Table>
          <div class="items-summary" v-if="form.items.length > 0">
            <span>合计金额: <strong>{{ formatMoney(totalAmount) }}</strong></span>
            <span style="margin-left: 20px;">合计税额: <strong>{{ formatMoney(totalTax) }}</strong></span>
            <span style="margin-left: 20px;">价税合计: <strong>{{ formatMoney(totalAmount + totalTax) }}</strong></span>
          </div>
        </div>
      </Form>
      <div slot="footer">
        <Button color="primary" @click="save" size="l">保存</Button>
        <Button @click="showModal = false" size="l">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import invoiceApi from '../../api/invoice';
import businessTypeApi from '../../api/invoicebusinesstype';

export default {
  name: 'Invoice',
  data() {
    return {
      list: [],
      loading: false,
      statistics: { byType: [], currentMonthAmount: 0 },
      showModal: false,
      isEdit: false,
      form: {
        type: 0,
        businessTypeId: null,
        invoiceCode: '',
        invoiceNumber: '',
        tradeDate: null,
        customerName: '',
        creditCode: '',
        address: '',
        amount: null,
        taxAmount: null,
        note: '',
        items: []
      },
      invoiceTypes: [
        { title: '销项发票', key: 0 },
        { title: '进项发票', key: 1 }
      ],
      businessTypes: [],
      rules: {
        type: [{ required: true, message: '请选择发票类型' }],
        tradeDate: [{ required: true, message: '请选择交易日期' }],
        invoiceCode: [{ required: true, message: '请输入发票代码' }],
        invoiceNumber: [{ required: true, message: '请输入发票号码' }]
      }
    };
  },
  computed: {
    totalAmount() {
      return this.form.items.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);
    },
    totalTax() {
      return this.form.items.reduce((sum, item) => sum + (parseFloat(item.tax) || 0), 0);
    }
  },
  mounted() {
    this.load();
    this.loadStatistics();
    this.loadBusinessTypes();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const res = await invoiceApi.getInvoices();
        this.list = res.data || [];
      } finally {
        this.loading = false;
      }
    },
    async loadStatistics() {
      try {
        const res = await invoiceApi.getInvoiceStatistics();
        this.statistics = res.data || { byType: [], currentMonthAmount: 0 };
      } catch (e) {
        console.error('加载统计失败', e);
      }
    },
    async loadBusinessTypes() {
      try {
        const res = await businessTypeApi.getBusinessTypes();
        this.businessTypes = res.data || [];
      } catch (e) {
        console.error('加载业务类型失败', e);
      }
    },
    openCreate() {
      this.isEdit = false;
      this.form = {
        type: 0,
        businessTypeId: null,
        invoiceCode: '',
        invoiceNumber: '',
        tradeDate: new Date(),
        customerName: '',
        creditCode: '',
        address: '',
        amount: null,
        taxAmount: null,
        note: '',
        items: []
      };
      this.showModal = true;
    },
    async openEdit(data) {
      this.isEdit = true;
      try {
        const res = await invoiceApi.getInvoice(data.id);
        if (res.data && res.data.invoice) {
          this.form = { ...res.data.invoice };
          this.form.items = res.data.items || [];
        } else {
          this.form = { ...data, items: [] };
        }
        this.showModal = true;
      } catch (e) {
        this.$Message.error('加载发票详情失败');
      }
    },
    addItem() {
      this.form.items.push({
        goodsName: '',
        specification: '',
        unit: '',
        quantity: 1,
        amount: null,
        taxRate: 13,
        tax: null
      });
    },
    removeItem(index) {
      this.form.items.splice(index, 1);
      this.calcTotalAmount();
    },
    calcItemAmount(item) {
      // 根据数量和单价计算金额（如果有单价的话）
      this.calcItemTax(item);
      this.calcTotalAmount();
    },
    calcItemTax(item) {
      // 计算税额
      const amount = parseFloat(item.amount) || 0;
      const taxRate = parseFloat(item.taxRate) || 0;
      item.tax = (amount * taxRate / 100).toFixed(2);
    },
    calcTotalAmount() {
      // 自动计算主表的金额和税额
      this.form.amount = this.totalAmount;
      this.form.taxAmount = this.totalTax;
    },
    async save() {
      const valid = await this.$refs.form.valid();
      if (!valid) return;

      // 调试：打印表单数据
      console.log('保存的表单数据:', JSON.stringify(this.form));

      try {
        if (this.isEdit) {
          await invoiceApi.updateInvoice(this.form.id, this.form);
        } else {
          await invoiceApi.createInvoice(this.form);
        }
        this.showModal = false;
        this.$Message.success('保存成功');
        this.load();
        this.loadStatistics();
      } catch (e) {
        this.$Message.error(e.msg || '保存失败');
      }
    },
    async voidInvoice(data) {
      if (!confirm(`确认作废发票 ${data.invoiceNumber}？`)) return;
      try {
        await invoiceApi.voidInvoice(data.id);
        this.$Message.success('作废成功');
        this.load();
        this.loadStatistics();
      } catch (e) {
        this.$Message.error(e.msg || '作废失败');
      }
    },
    async remove(data) {
      if (!confirm(`确认删除发票 ${data.invoiceNumber}？此操作不可恢复！`)) return;
      try {
        await invoiceApi.deleteInvoice(data.id);
        this.$Message.success('删除成功');
        this.load();
        this.loadStatistics();
      } catch (e) {
        this.$Message.error(e.msg || '删除失败');
      }
    },
    goToBusinessType() {
      this.$router.push('/invoice/business-type');
    },
    getInvoiceTypeText(type) {
      const map = { 0: '销项', 1: '进项' };
      return map[type] || '未知';
    },
    getStatusText(state) {
      const map = { 0: '正常', 1: '已作废' };
      return map[state] || '未知';
    },
    getTypeCount(type) {
      const item = this.statistics.byType.find(t => t.type === type);
      return item ? item.count : 0;
    },
    formatMoney(value) {
      if (value === null || value === undefined) return '0.00';
      return parseFloat(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }
};
</script>

<style scoped>
.invoice-page {
  padding: 20px;
}
.toolbar {
  margin-bottom: 16px;
}
.toolbar button {
  margin-right: 8px;
}
.statistics-cards {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
}
.stat-card {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  text-align: center;
}
.stat-label {
  color: #666;
  font-size: 14px;
  margin-bottom: 8px;
}
.stat-value {
  color: #1890ff;
  font-size: 24px;
  font-weight: 600;
}
.type-0 { color: #52c41a; font-weight: 500; }
.type-1 { color: #1890ff; font-weight: 500; }
.status-0 { color: #52c41a; }
.status-1 { color: #999; text-decoration: line-through; }

/* 弹窗头部标题 */
.modal-header {
  margin: -20px -20px 20px -20px;
  padding: 20px 24px;
  background: linear-gradient(135deg, #1890ff 0%, #36cfc9 100%);
  border-radius: 4px 4px 0 0;
}
.modal-title {
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 4px;
}
.modal-subtitle {
  font-size: 13px;
  color: rgba(255,255,255,0.85);
}

/* 双列表单布局 */
.form-row {
  display: flex;
  gap: 24px;
  margin-bottom: 16px;
}
.form-col {
  flex: 1;
  margin-bottom: 0;
}
.form-col :deep(.h-form-item-label) {
  font-size: 15px;
  font-weight: 500;
  color: #333;
}
.form-col :deep(.h-input),
.form-col :deep(.h-select),
.form-col :deep(.h-datepicker) {
  width: 100%;
  height: 38px;
  font-size: 14px;
}
.form-col :deep(.h-input input),
.form-col :deep(.h-select-value) {
  font-size: 14px;
}

/* 发票项目明细样式 */
.items-section {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e8e8e8;
}
.items-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.items-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.items-summary {
  margin-top: 10px;
  padding: 10px;
  background: #f5f5f5;
  border-radius: 4px;
  text-align: right;
  font-size: 14px;
}
.items-summary strong {
  color: #1890ff;
  font-size: 16px;
}
</style>
